function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m21.75 5.5h-19.5c-1.241 0-2.25-1.009-2.25-2.25s1.009-2.25 2.25-2.25h19.5c1.241 0 2.25 1.009 2.25 2.25s-1.009 2.25-2.25 2.25zm-19.5-3c-.414 0-.75.336-.75.75s.336.75.75.75h19.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m20.5 18h-17c-.965 0-1.75-.785-1.75-1.75v-11.5c0-.414.336-.75.75-.75h19c.414 0 .75.336.75.75v11.5c0 .965-.785 1.75-1.75 1.75zm-17.25-12.5v10.75c0 .138.112.25.25.25h17c.138 0 .25-.112.25-.25v-10.75z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m12 24c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-2.5c-.276 0-.5.224-.5.5s.224.5.5.5.5-.224.5-.5-.224-.5-.5-.5z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m12 21.25c-.414 0-.75-.336-.75-.75v-3c0-.414.336-.75.75-.75s.75.336.75.75v3c0 .414-.336.75-.75.75z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m6.75 15c-.195 0-.391-.076-.538-.227-.289-.297-.282-.772.015-1.061l3.818-3.714c.251-.245.638-.282.931-.092l2.301 1.493 3.393-4.126c.262-.319.736-.366 1.056-.103s.366.735.103 1.056l-3.818 4.643c-.242.294-.668.359-.987.153l-2.361-1.532-3.389 3.297c-.147.142-.336.213-.524.213z"
});

var SvgSpecification = function SvgSpecification(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31__x2C_5_px",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpecification, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/specification.a088a084.svg";
export { ForwardRef as ReactComponent };